package computation

import scala.math.{exp, log}

object ComputationLogic {
  val fValMap: Map[Int, (String, (Double, Double))] =
    Map(
      1  -> ("Sylvaroad&trade; RP 1000", (0.151, -1.645)),
      2  -> ("PrePhalt® FBK", (0.137, -1.498)),
      3  -> ("Storflux", (0.101, -1.098)),
      4  -> ("ADM", (0.145, -1.515)),
      5  -> ("ReJUVN8&trade;", (0.163, -1.740)),
      6  -> ("EVOFLEX&trade; CA", (0.152, -1.618)),
      7  -> ("Hydrogreen S&trade;", (0.143, -1.578)),
      8  -> ("Iterlene ACF 1000", (0.132, -1.420)),
      9  -> ("Iterlene ACF 2000", (0.176, -1.853)),
      10 -> ("Paramo 182", (0.141, -1.430)),
      11 -> ("Paramo Exop 23", (0.082, -0.955)),
      12 -> ("ANOVA", (0.141, -1.655)),
    )

  def getFValValue(fVal: Int): (Double, Double) = {
    fValMap(fVal)._2
  }

  def compute(a: Double,
              b: Double,
              c: Double,
              d: Double,
              e: Double,
              a1: Double,
              a2: Double,
              g: Double): (Double, Double) = {
    (exp(a1 * (g + log(d) / a1)), e + a2 * g)
  }

  def getFValValue(f: String): (Double, Double) = {
    fValMap.find(x => x._2._1 == f).get._2._2
  }
}



// WEBPACK FOOTER //
// /home/petr/repos/pancapp/javascriptApp/src/main/scala/computation/ComputationLogic.scala